import { CallEventTypes } from '@gem/call/constants';

// import { initCallListener } from 'APP/model/call/b2c.call/callModel.events';
import Entities from 'STORE';
import { IncomingCall } from 'STORE/IncomingCalls/IncomingCall/IncomingCall';

const getStream = (
  _channelId: string,
  _onUserCallData: (data: any) => void,
  _onActiveCallData: (data: any) => void
): (() => void) | null => null;
// initCallListener({
//   channelId: channelId,
//   onUserCallData,
//   onActiveCallData,
// });

export const callStreamService = (call: IncomingCall): (() => void) => {
  const onUserCallData = (data: any): void => {
    const userId = data.userId.toString();
    if (
      userId === Entities.usersStore.Me.id &&
      (data.status === CallEventTypes.Joined || data.status === CallEventTypes.Declined)
    ) {
      Entities.IncomingCalls.delete(call.channelId, call.groupId);
    }
  };

  const onActiveCallData = (data: any): void => {
    if (data.status === CallEventTypes.Finished) {
      Entities.IncomingCalls.delete(call.channelId, call.groupId);
    }
  };

  const disposeCallStream = getStream(call.channelId, onUserCallData, onActiveCallData);

  return () => {
    if (disposeCallStream) {
      disposeCallStream();
    }
  };
};
